import { useLocale } from '../i18n/locale';

/**
 * ID | EN, as a two-position switch.
 *
 * Deliberately not a dropdown: with two options a select costs a click to
 * discover and another to choose, and hides which one is active until it is
 * opened. Both codes stay visible, and the active one is obvious.
 */
export function LocaleSwitch({ className = '' }: { className?: string }) {
  const { locale, setLocale } = useLocale();

  return (
    <div
      role="group"
      aria-label="Bahasa / Language"
      className={`inline-flex overflow-hidden rounded-lg border border-white/20 ${className}`}
    >
      {(['id', 'en'] as const).map((code) => {
        const active = locale === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLocale(code)}
            aria-pressed={active}
            className={`cursor-pointer border-0 px-2 py-1 text-[11px] font-bold tracking-wide uppercase transition-colors ${
              active ? 'bg-white text-slate-800' : 'bg-transparent text-white/70 hover:text-white'
            }`}
          >
            {code}
          </button>
        );
      })}
    </div>
  );
}
